<search-results-shared
  *ngIf="isSearchActive"
  [isLoading]="isLoading"
  [searchResultHint]="searchResultHint"
  [results]="results"
  [selectedSearchOption]="selectedSearchOption"
  (pageChanged)="onPageChanged($event)"
  (sortCategory)="onSortCategory($event)"
>
  <div search-pagination *ngIf="searchState?.pagination && count > defaultCount" class="pagination-holder">
    <ngb-pagination
      class="w-100 pt-3 d-flex justify-content-end pagination custom-pagination"
      [class.pagination-sm]="innerWidth <= mobileScreenWidth"
      data-test-id="pagination-box"
      [collectionSize]="count"
      [(page)]="searchState.pagination.currentPage"
      [maxSize]="3"
      [pageSize]="defaultCount"
      [rotate]="true"
      (pageChange)="onPageChanged($event)"
    ></ngb-pagination>
  </div>

  <div search-results class="col-md-6 mb-4" *ngFor="let result of results; index as i">
    <app-card
      [data]="result.item"
      [index]="i"
      [status]="result.view_type === 'deleted' ? DELETED : EMPTY"
      [type]="inviteCardType ? inviteCardType : CARD_TYPES_BY_ENTITY_TYPE[result.entity_kind]"
      (action)="onAction($event)"
    ></app-card>
  </div>
</search-results-shared>
